export default [
  {
    path: "/",
    redirect: { name: "Home" },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login.vue"),
    meta: {
      title: "登录",
      anonymous: true,
    },
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("@/views/Home.vue"),
    meta: {
      title: "首页",
    },
  },
  {
    path: "/password",
    name: "Password",
    component: () => import("@/views/User/Password.vue"),
    meta: {
      title: "忘记密码",
      anonymous: true,
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("@/views/User/Register.vue"),
    meta: {
      title: "注册账号",
      anonymous: true,
    },
  },
  {
    path: "/change",
    name: "ChangePassword",
    component: () => import("@/views/User/ChangePassword.vue"),
    meta: {
      title: "修改密码",
    },
  },
];
